import { Card, CardBody, Col, Row } from "reactstrap";
import { ARTICAL_DATA_2 } from "../../../Data/Faq";
import { H4, P } from "../../../AbstractElements";

const ArticeVideo2 = () => {
  return (
    <Col xl="4" md="6">
      <Row>
        {ARTICAL_DATA_2.map((item, i) => (
          <Col sm="12" key={i}>
            <Card>
              <CardBody>
                <div className="d-flex">
                  {item.iconClass}
                  <div className="flex-grow-1">
                    <H4 className="f-w-700">{item.title}</H4>
                    <P>{item.description}</P>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};
export default ArticeVideo2;
